const transformImage = ({ contentUrl: url, width, height }) => ({
    url,
    width,
    height,
});

export default transformImage;
